import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  className?: string
  id?: string
  target?: string
  title: string
  languageCode?: string
  languagePrefix?: string | null
  url: string
}

export const FooterMenuItem = memo(function FooterMenuItem({
  className,
  title,
  target,
  url,
}: Props) {
  if (!title) {
    return null
  }

  return (
    <Container>
      {URL && !target ? (
        <Anchor className={className} to={url} activeClassName="active">
          {title}
        </Anchor>
      ) : URL && target ? (
        <External href={url} target={target}>
          {title}
        </External>
      ) : (
        <NoLink>{title}</NoLink>
      )}
    </Container>
  )
})

const Container = styled.li`
  display: block;
`

const Style = css`
  transition: 0.2s ease-in-out;

  &.active {
    pointer-events: none;
  }
  &:hover {
    opacity: 0.5;
  }
`

const Anchor = styled(Link)`
  ${Style}
`

const External = styled.a`
  ${Style}
`

const NoLink = styled.div`
  ${Style}
`
